export * from './lib/hint/hint.component';
